import { useState } from "react";
import { api } from "@/lib/api";

export default function EvaluationCard({ lesson, activity, defaultPlaceholder, onScored }) {
  const [text, setText] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    if (!text.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const res = await api.evaluate({
        lesson_id: lesson.id,
        activity,
        text,
      });
      setResult(res);
      onScored && onScored(res);
    } catch (e) {
      setError(e?.response?.data?.detail || "تعذّر إجراء التقييم. حاول مجدّدًا.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={`eval-card-${activity}`}>
      <textarea
        data-testid={`eval-input-${activity}`}
        className="balagha-input"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={defaultPlaceholder}
      />
      <div className="row" style={{ marginTop: 10 }}>
        <button
          data-testid={`eval-submit-${activity}`}
          className="btn btn-primary"
          onClick={submit}
          disabled={loading || !text.trim()}
        >
          {loading ? "يقيّم..." : "تقييم بالذكاء الاصطناعي ✨"}
        </button>
        {result && (
          <span className="muted" style={{ fontSize: 13 }}>
            النتيجة: <strong style={{ color: "var(--gold)" }}>{result.overall_score}/100</strong>
          </span>
        )}
      </div>
      {error && <div className="hint" style={{ color: "#ff7aa8" }}>{error}</div>}

      {result && (
        <div className="eval-card" data-testid={`eval-result-${activity}`}>
          <div className="eval-score">
            <div
              className="ring"
              style={{ "--p": result.overall_score }}
              data-testid={`eval-ring-${activity}`}
            >
              <span>{result.overall_score}</span>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>تقييم المعلّم الذكي</div>
              <div className="feedback-block">{result.feedback}</div>
            </div>
          </div>

          <div className="criteria-list">
            {result.criteria?.map((c, i) => (
              <div key={i} className="criterion">
                <span className="label">{c.name}</span>
                <span className="bar"><i style={{ width: `${c.score}%` }} /></span>
                <span className="val">{c.score}</span>
              </div>
            ))}
          </div>

          {result.improvement && (
            <div style={{ marginTop: 12 }}>
              <div className="muted" style={{ fontSize: 13, marginBottom: 4 }}>اقتراح للتحسين</div>
              <div className="feedback-block">{result.improvement}</div>
            </div>
          )}

          {result.rewritten && (
            <div className="improve-out">
              ✨ صياغة بلاغية مقترحة:
              <div style={{ marginTop: 6 }}>«{result.rewritten}»</div>
            </div>
          )}

          <div className="row" style={{ marginTop: 12 }}>
            <span className="badge-pill">+{result.xp_earned} XP</span>
            {result.used_rhetoric && (
              <span className="badge-pill">أسلوب بلاغي مميّز ✨</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
